/*import React from 'react';
import "./Product.css";
import { useStateValue } from './StateProvider';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { db, auth } from './firebase'; 
import { doc, setDoc, increment } from "firebase/firestore";

function Product({id, originalID, title, image, description, price, quantity, size, alter, variants = [], navigateOnClick = false}) {
    const [{basket}, dispatch] = useStateValue();
    const navigate = useNavigate();

    const hasVariants = Array.isArray(variants) && variants.length > 0;
    const cheapestVariant = hasVariants 
        ? variants.reduce((min, v) => Number(v.price) < Number(min.price) ? v : min)
        : null;

    // Questa è la tua costante: la usiamo per il rendering
    const displayPrice = hasVariants ? Number(cheapestVariant.price) : Number(price);

    const addToBasket = async (e) => {
        e.stopPropagation();
        const user = auth.currentUser;
    
        // Usiamo i dati della variante economica già calcolata sopra
        const finalID = hasVariants ? cheapestVariant.originalID : (originalID ?? id);
        const finalPrice = displayPrice;
        const finalSize = hasVariants ? cheapestVariant.size : (size ?? null);
    
        const itemToAdd = {
            id: finalID,
            title: title,
            image: image,
            price: finalPrice,
            quantity: Number(quantity) || 1,
            size: finalSize
        };

        const itemKey = `${finalID}_${finalSize}`;
    
        dispatch({ type: 'ADD_TO_BASKET', item: itemToAdd });
    
        if (user) {
            try {
                const cartRef = doc(db, "users", user.uid, "carrello", itemKey);
                await setDoc(cartRef, {
                    ...itemToAdd,
                    quantity: increment(itemToAdd.quantity)
                }, { merge: true });
            } catch (error) {
                console.error("Errore salvataggio:", error);
            }
        }
        toast.success(`${title} aggiunto!`);
    }

    const goToProduct = () => {
        if (navigateOnClick) {
            navigate(`/product/${id}`);
        }
    }

  return (
    <div className='product'>
        <div className='product_info'>
            <p>{title}</p>
            <p className='product_price'>
                <small>€</small>
                <strong>{displayPrice.toFixed(2)}</strong>
            </p>
        </div>
        <img className='product_image' src={image} alt={alter} onClick={goToProduct} style={{ cursor : navigateOnClick ? 'pointer' : 'default' }}/>
        <button onClick={addToBasket}>Aggiungi al carrello</button>
    </div>
  )
}

export default Product*/


import React from 'react';
import "./Product.css";
import { useStateValue } from './StateProvider';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { db, auth } from './firebase'; 
import { doc, setDoc, increment } from "firebase/firestore";

function Product({id, originalID, title, image, peso, price, quantity, size, alter, variants = [], navigateOnClick = false}) {
    const [{basket}, dispatch] = useStateValue();
    const navigate = useNavigate();

    const hasVariants = Array.isArray(variants) && variants.length > 0;
    const cheapestVariant = hasVariants 
        ? variants.reduce((min, v) => Number(v.price) < Number(min.price) ? v : min)
        : null;

    // Calcoliamo sia il prezzo che l'immagine da mostrare della variante più economica
    const displayPrice = hasVariants ? Number(cheapestVariant.price) : Number(price);
    const displayImage = (hasVariants && cheapestVariant.image) ? cheapestVariant.image : image;

    const addToBasket = async (e) => {
        e.stopPropagation();
        const user = auth.currentUser;
    
        // Usiamo i dati della variante economica già calcolata
        const finalID = hasVariants ? cheapestVariant.originalID : (originalID ?? id);
        const finalPrice = displayPrice;
        const finalImage = displayImage; // Usiamo l'immagine della variante
        const finalSize = hasVariants ? cheapestVariant.size : (size ?? null);
        const finalPeso = hasVariants ? cheapestVariant.peso : (peso ?? null);
    
        const itemToAdd = {
            id: id,
            originalID: finalID,
            title: title,
            image: finalImage,
            price: finalPrice,
            quantity: Number(quantity) || 1,
            peso: finalPeso,
            size: finalSize
        };

        const itemKey = `${finalID}_${finalSize}`;
    
        dispatch({ type: 'ADD_TO_BASKET', item: itemToAdd });
    
        if (user) {
            try {
                const cartRef = doc(db, "users", user.uid, "carrello", itemKey);
                await setDoc(cartRef, {
                    ...itemToAdd,
                    quantity: increment(itemToAdd.quantity)
                }, { merge: true });
            } catch (error) {
                console.error("Errore salvataggio:", error);
            }
        }
        toast.success(`${title} aggiunto!`);
    }

    const goToProduct = () => {
        if (navigateOnClick) {
            navigate(`/product/${id}`);
        }
    }

  return (
    <div className='product'>
        <div className='product_info'>
            <p>{title}</p>
            <p className='product_price'>
                <small>€</small>
                <strong>{displayPrice.toFixed(2)}</strong>
            </p>
        </div>
        {/* Ora qui viene usata l'immagine dinamica displayImage */}
        <img className='product_image' src={displayImage} alt={alter} onClick={goToProduct} style={{ cursor : navigateOnClick ? 'pointer' : 'default' }}/>
        <button onClick={addToBasket}>Aggiungi al carrello</button>
    </div>
  )
}

export default Product;